import { toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, vModelSelect as _vModelSelect, withDirectives as _withDirectives, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode } from "vue"

const _hoisted_1 = { class: "parent ml-3" }
const _hoisted_2 = {
  class: "ml-3",
  style: {"display":"flex","justify-content":"center","align-items":"baseline"}
}
const _hoisted_3 = {
  key: 0,
  style: {"font-size":"16px"}
}
const _hoisted_4 = ["aria-label"]
const _hoisted_5 = ["value"]
const _hoisted_6 = { style: {"display":"flex","justify-content":"center","align-items":"baseline"} }
const _hoisted_7 = {
  key: 0,
  style: {"font-size":"16px"}
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Toggle = _resolveComponent("Toggle")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      (+(_ctx.activeUserId ?? 0) == 101)
        ? (_openBlock(), _createElementBlock("p", _hoisted_3, _toDisplayString(_ctx.$t("dropDownComp.defaultColor")), 1))
        : _createCommentVNode("", true),
      (_ctx.options != null)
        ? _withDirectives((_openBlock(), _createElementBlock("select", {
            key: 1,
            disabled: true,
            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.defaultColor) = $event)),
            onChange: _cache[1] || (_cache[1] = ($event: any) => (_ctx.$emit('changeDefaultColorSelectorValue', _ctx.defaultColor))),
            style: {"margin-left":"1rem","font-family":"Arial, sans-serif","border-radius":"4px","height":"28px","border-color":"rgb(191, 198, 203)","width":"122px"},
            id: "defaultColor",
            "aria-label": _ctx.$t('dropDownComp.defaultColor')
          }, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.options, (option) => {
              return (_openBlock(), _createElementBlock("option", {
                key: option.Id,
                value: option.name
              }, _toDisplayString(option.value), 9, _hoisted_5))
            }), 128))
          ], 40, _hoisted_4)), [
            [_vModelSelect, _ctx.defaultColor]
          ])
        : _createCommentVNode("", true)
    ]),
    _createElementVNode("div", _hoisted_6, [
      (+(_ctx.activeUserId ?? 0) == 101)
        ? (_openBlock(), _createElementBlock("p", _hoisted_7, _toDisplayString(_ctx.$t("dropDownComp.shadeConfiguartion")), 1))
        : _createCommentVNode("", true),
      _createVNode(_component_Toggle, {
        toggleValue: _ctx.toggleButtonVal,
        onOnToggleChange: _ctx.toggleEvent
      }, null, 8, ["toggleValue", "onOnToggleChange"])
    ])
  ]))
}